export default function duplicateLens(state, action) {
  const { cameras } = state
  const { id, location, newId, imagerId } = action
  const camera = cameras.find(c => c.id === id)

  return Object.assign({}, state, {
    cameras: [
      ...cameras,
      {
        ...camera,
        id: newId,
        location,
        imagerId
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/reducers/duplicateLens.js